import React from "react";
import { useSelector } from "react-redux";
import { RootState } from "typedefs";

import { TimeZoneState } from "app/reducers/scheduling/timeZone";
import { TimeZoneModel } from "app/models/scheduling/TimeZoneModel";
import { useTimeZonesModel } from "./indexModel";

import styles from "./styles.module.scss";

type PropsDef = {
  timeZone: string;
};

export default function TimezoneInfo(props: PropsDef) {
  const { timeZone } = props;

  const { pending: loadingTimeZones } = useTimeZonesModel();


  const timeZones = useSelector(
    (state: RootState): TimeZoneState => state.schedulingTimeZones,
  );

  if (loadingTimeZones) {
    return null;
  }

  const timezone =
    timeZones?.data?.find(
      (item: TimeZoneModel) => item?.value === timeZone,
    )?.display || "";

  const [timeZoneOffset, ...timeZoneName] = timezone.split(" ");

  return (
    <div className={styles.container}>
      <i className="ico ico-globe" />
      <span>{timeZoneOffset}</span>
      <span>{timeZoneName.join(" ")}</span>
    </div>
  );
}
